import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { ActivityTemplate } from "../Entities/Activity/ActivityTemplate";
import { ActivityTemplateInterface } from "../Entities/Activity/ActivityTemplateInterface";

class ActivityTemplateFactory extends Factory implements FactoryInterface {

  public create(data: any): ActivityTemplateInterface {
    return new ActivityTemplate({
      id: data.id,
      name: data.name,
      removed: data.removed
    });
  }

  public reinitialize(data: any): ActivityTemplateInterface {
    return new ActivityTemplate({
      ...data
    });
  }
}

export default new ActivityTemplateFactory();
